
import consts from "@/consts.js";
import Request from './request';
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
    return Request('get', "api/templates", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/templates/select", data, false, false, true);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id)
        return Request('patch', "api/templates/edit?id=" + id, data);
    else
        return Request('post', "api/templates/add", data);
}

async function del(id) {// 删除数据
    return Request('delete', "api/templates/" + id);
}

async function downloadImportTemplate(id) {// 下载导入模板
    return Request('post', "api/material-templates/import-template-export?template_id=" + id);
}

async function imports(id, file, isForceImport = false) {// 导入
    var data = new FormData();
    data.append("excel", file);
    if (isForceImport) {
        data.append("force_import", true);
    }
    return Request('post', "api/material-templates/import/" + id, data);
}

async function exports(id) {
    // 导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/material-templates/export/'+id)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }

async function getCategoryServiceList(templateId) {
    return Request('get', "api/material-templates/get-category-service-list/" + templateId);
}

async function saveCategoryService(data) {
    return Request('post', "api/material-templates/save-category-service", data);
}

  
export default {
    fetch,
    fetchAllForSelect,
    save,
    del,
    downloadImportTemplate,
    imports,
    exports,
    getCategoryServiceList,
    saveCategoryService,
};